import { render, staticRenderFns } from "./QuestionsFlow.vue?vue&type=template&id=486c8fd3&scoped=true&"
import script from "./QuestionsFlow.vue?vue&type=script&lang=js&"
export * from "./QuestionsFlow.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsFlow.vue?vue&type=style&index=0&id=486c8fd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c8fd3",
  null
  
)

export default component.exports